import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="date-validation"
export default class extends Controller {
  static targets = ["input"];

  validate() {
    const fieldType = this.inputTarget.dataset.fieldType;
    const value = this.inputTarget.value;

    this.clearErrors();

    if (!this.isValidDate(value)) {
      this.showError("Please enter a valid date");
      return false;
    }

    if (this.isPastDate(value)) {
      this.showError("Date cannot be in the past");
      return false;
    }

    // For end_date, compare with start_date
    if (fieldType === "end_date") {
      const startDateInput = document.querySelector(
        '[data-field-type="start_date"]'
      );
      if (startDateInput && startDateInput.value) {
        if (new Date(value) < new Date(startDateInput.value)) {
          this.showError("End date cannot be before start date");
          return false;
        }
      }
    }

    return true;
  }

  isValidDate(dateStr) {
    const date = new Date(dateStr);
    return date instanceof Date && !isNaN(date);
  }

  isPastDate(dateStr) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const inputDate = new Date(dateStr);
    return inputDate < today;
  }

  showError(message) {
    const errorDiv = document.createElement("div");
    errorDiv.classList.add("invalid-feedback", "d-block");
    errorDiv.textContent = message;
    this.inputTarget.classList.add("is-invalid");
    this.inputTarget.parentNode.appendChild(errorDiv);
  }

  clearErrors() {
    const errorMessages = this.element.querySelectorAll(".invalid-feedback");
    errorMessages.forEach((el) => el.remove());
    this.inputTarget.classList.remove("is-invalid");
  }
}
